export var HarriEngageRoutes = {
    "/brand/:brand_id/harri-engage": {
        "loginRequired": true,
        "name": "harri-engage",
        "type": "frontend",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./harri-engage.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../offer-templates/offer-templates.module.js");
                }
            }
        ]
    }
};